import $ from "jquery";
import tinymce from 'tinymce';
import bootbox from 'bootbox';
import { Modal, Carousel } from "bootstrap";
// UI + theme (TinyMCE 6/7)
import 'tinymce/icons/default';
import 'tinymce/themes/silver';
// Model (pri niektorých bundloch treba)
import 'tinymce/models/dom';
$(function () {
    $("#loading-spinner").addClass("spinner-border text-primary");
    var lastRequest = null;
    $('#materialDetailModal')
        .off('show.bs.modal.zuba')
        .on('show.bs.modal.zuba', function (event) {
        var _a, _b;
        var $trigger = $(event.relatedTarget).closest('[data-bs-toggle="modal"]');
        console.log("show.bs.modal fired, relatedTarget:", event.relatedTarget);
        var title = $trigger.attr('data-bs-title') // CTA používa data-bs-title
            || String((_a = $trigger.data('title')) !== null && _a !== void 0 ? _a : ''); // materiály používajú data-title
        var url = String((_b = $trigger.data('url')) !== null && _b !== void 0 ? _b : '');
        // 1) reset obsahu hneď, aby tam nikdy nezostal starý material
        $("#materialDetailDiv").html("");
        $("#materialDetailDiv").addClass("is-loading"); // voliteľné (ak máš CSS)
        // ak máš title element
        $('#materialDetailTitle').text(title);
        // 2) abort predchádzajúci request (race condition fix)
        if (lastRequest)
            lastRequest.abort();
        lastRequest = $.ajax({
            type: 'GET',
            url: url,
            dataType: 'json', // ✅ lebo Info vracia Json { html: ... }
            beforeSend: function () {
                $('#spinnerContainer').removeClass('d-none');
            },
            complete: function () {
                $('#spinnerContainer').addClass('d-none');
                $("#materialDetailDiv").removeClass("is-loading");
            }
        });
        lastRequest.done(function (res) {
            var _a;
            // bezpečne
            var html = (_a = res === null || res === void 0 ? void 0 : res.html) !== null && _a !== void 0 ? _a : "";
            $("#materialDetailDiv").html(html);
        });
        lastRequest.fail(function (jqXHR) {
            if (jqXHR.statusText === "abort")
                return;
            console.error(jqXHR);
            $("#materialDetailDiv").html("<div class='p-3'>Nepodarilo sa načítať obsah.</div>");
        });
    });
    $('#materialDetailModal').on('hidden.bs.modal', function () {
        $("#materialDetailDiv").html("");
    });
    $('#headlineDetailModal')
        .off('show.bs.modal.zuba')
        .on('show.bs.modal.zuba', function (event) {
        var _a, _b;
        var $trigger = $(event.relatedTarget).closest('[data-bs-toggle="modal"]');
        console.log("show.bs.modal fired, relatedTarget:", event.relatedTarget);
        var title = $trigger.attr('data-bs-title') // CTA používa data-bs-title
            || String((_a = $trigger.data('title')) !== null && _a !== void 0 ? _a : ''); // materiály používajú data-title
        var url = String((_b = $trigger.data('url')) !== null && _b !== void 0 ? _b : '');
        // 1) reset obsahu hneď, aby tam nikdy nezostal starý material
        $("#headlineDetailDiv").html("");
        $("#headlineDetailDiv").addClass("is-loading"); // voliteľné (ak máš CSS)
        // 2) abort predchádzajúci request (race condition fix)
        if (lastRequest)
            lastRequest.abort();
        lastRequest = $.ajax({
            type: 'GET',
            url: url,
            dataType: 'json', // ✅ lebo Info vracia Json { html: ... }
            beforeSend: function () {
                $('#spinnerContainer').removeClass('d-none');
            },
            complete: function () {
                $('#spinnerContainer').addClass('d-none');
                $("#headlineDetailDiv").removeClass("is-loading");
            }
        });
        lastRequest.done(function (res) {
            var _a;
            // bezpečne
            var html = (_a = res === null || res === void 0 ? void 0 : res.html) !== null && _a !== void 0 ? _a : "";
            $("#headlineDetailDiv").html(html);
        });
        lastRequest.fail(function (jqXHR) {
            if (jqXHR.statusText === "abort")
                return;
            console.error(jqXHR);
            $("#headlineDetailDiv").html("<div class='p-3'>Nepodarilo sa načítať obsah.</div>");
        });
    });
    $('#headlineDetailModal').on('hidden.bs.modal', function () {
        $("#headlineDetailDiv").html("");
    });
    // =========================
    // PRODUCTS POPUP (Home top 6)
    // =========================
    initProductsPopup();
});
// =========================
// Products popup init
// =========================
function initProductsPopup() {
    var $modal = $("#productPopup");
    if ($modal.length === 0)
        return; // Home nemusí mať modal markup
    var modal = Modal.getOrCreateInstance($modal[0], {
        backdrop: true,
        keyboard: true,
        focus: true
    });
    var $inner = $("#productPopupInner");
    var $dots = $("#productPopupDots");
    var $title = $("#productPopupTitle");
    var carouselEl = document.getElementById("productPopupCarousel");
    if (!carouselEl)
        return;
    var carousel = Carousel.getOrCreateInstance(carouselEl, {
        interval: false,
        ride: false,
        wrap: true,
        touch: true
    });
    function render(images) {
        $inner.empty();
        $dots.empty();
        images.forEach(function (url, i) {
            var active = i === 0 ? "active" : "";
            $inner.append("\n                <div class=\"carousel-item ".concat(active, "\">\n                    <img class=\"zuba-product-modal-img\" src=\"").concat(url, "\" alt=\"\">\n                </div>\n            "));
            $dots.append("\n                <button type=\"button\"\n                        class=\"".concat(i === 0 ? "is-active" : "", "\"\n                        data-dot=\"").concat(i, "\"\n                        aria-label=\"Slide ").concat(i + 1, "\">\n                </button>\n            "));
        });
        carousel.to(0);
        setActiveDot(0);
    }
    function setActiveDot(index) {
        $dots.find("button").removeClass("is-active");
        $dots.find("button[data-dot=\"".concat(index, "\"]")).addClass("is-active");
    }
    // Open popup (Home top produkty musia mať .js-product-popup + data-popup-images)
    $(document).on("click", ".js-product-popup", function (e) {
        var _a, _b;
        e.preventDefault();
        var title = String((_a = $(this).data("popup-title")) !== null && _a !== void 0 ? _a : "");
        $title.text(title);
        var raw = (_b = $(this).attr("data-popup-images")) !== null && _b !== void 0 ? _b : "[]";
        var images = [];
        try {
            images = JSON.parse(raw);
        }
        catch (_c) {
            images = [];
        }
        if (!images || images.length === 0)
            return;
        render(images);
        modal.show();
    });
    // Dots click
    $(document).on("click", "#productPopupDots button", function () {
        var i = parseInt(String($(this).data("dot")), 10);
        if (!isNaN(i))
            carousel.to(i);
    });
    // Update dots on slide
    $(carouselEl).on("slid.bs.carousel", function () {
        var idx = $(carouselEl).find(".carousel-item.active").index();
        setActiveDot(idx);
    });
    // Desktop drag (pointer)
    var startX = null;
    var dragging = false;
    $(document).on("pointerdown", "#productPopupCarousel", function (ev) {
        var _a, _b;
        startX = (_b = (_a = ev.originalEvent) === null || _a === void 0 ? void 0 : _a.clientX) !== null && _b !== void 0 ? _b : null;
        dragging = true;
    });
    $(document).on("pointerup pointercancel", "#productPopupCarousel", function () {
        startX = null;
        dragging = false;
    });
    $(document).on("pointermove", "#productPopupCarousel", function (ev) {
        var _a, _b;
        if (!dragging || startX === null)
            return;
        var x = (_b = (_a = ev.originalEvent) === null || _a === void 0 ? void 0 : _a.clientX) !== null && _b !== void 0 ? _b : startX;
        var dx = x - startX;
        if (Math.abs(dx) > 60) {
            dx < 0 ? carousel.next() : carousel.prev();
            startX = null;
            dragging = false;
        }
    });
    // Reset pri zavretí
    $modal.on("hidden.bs.modal", function () {
        $inner.empty();
        $dots.empty();
        $title.text("");
    });
}
export function showMessage(message, title) {
    if (title === void 0) { title = ""; }
    if (title.length == 0)
        title = "ZUBA";
    bootbox.alert({
        title: title,
        message: message,
        className: "zuba-bootbox",
        backdrop: true,
        centerVertical: true
    });
}
export function initTinymce(textAreaId, minHight, bodyClass, contentCss) {
    if (bodyClass === void 0) { bodyClass = ''; }
    if (contentCss === void 0) { contentCss = ''; }
    if (contentCss === '')
        contentCss = '/css/editor-content.css';
    var existing = tinymce.EditorManager.get(textAreaId);
    if (existing)
        return;
    var mergedBodyClass = ['zuba-richtext', bodyClass].filter(Boolean).join(' ');
    tinymce.init({
        selector: '#' + textAreaId,
        license_key: 'gpl',
        resize: 'both',
        min_height: minHight,
        plugins: 'advlist lists link image table code',
        toolbar: 'styles | undo redo | ' +
            'bold italic | alignleft aligncenter alignright | ' +
            'bullist numlist outdent indent | link image | table | code',
        menubar: true, // môžeš dať true na test
        body_class: mergedBodyClass,
        content_css: contentCss,
        /* enable title field in the Image dialog*/
        image_title: true,
        images_upload_url: '/editor/upload',
        images_upload_credentials: true, // ak používaš cookies/auth
        /* enable automatic uploads of images represented by blob or data URIs*/
        automatic_uploads: true,
        file_picker_types: 'image',
        convert_urls: false,
        relative_urls: false,
        remove_script_host: false,
        image_class_list: [
            { title: 'Default', value: '' },
            { title: 'Left (wrap text)', value: 'zuba-rt-img-left' },
            { title: 'Right (wrap text)', value: 'zuba-rt-img-right' },
            { title: 'Center', value: 'zuba-rt-img-center' },
            { title: 'Full width', value: 'zuba-rt-img-full' }
        ],
        // --- Styles dropdown ---
        style_formats: [
            {
                title: 'Normal text',
                block: 'p',
                classes: 'zuba-rt-text'
            },
            {
                title: 'Lead / Perex',
                block: 'p',
                classes: 'zuba-rt-lead'
            },
            {
                title: 'Title (Organetto)',
                block: 'p',
                classes: 'zuba-rt-title'
            },
            {
                title: 'Section title',
                block: 'p',
                classes: 'zuba-rt-h2'
            },
            {
                title: 'Kicker (uppercase)',
                block: 'p',
                classes: 'zuba-rt-kicker'
            },
            {
                title: 'Small label',
                block: 'p',
                classes: 'zuba-rt-label'
            },
            {
                title: 'Note / Info box',
                block: 'p',
                classes: 'zuba-rt-note'
            },
            {
                title: 'Small text',
                block: 'p',
                classes: 'zuba-rt-small'
            },
            {
                title: 'Muted text',
                block: 'p',
                classes: 'zuba-rt-muted'
            }
        ],
        // --- Paste: nech neťahá štýly z Wordu ---
        paste_as_text: true,
        // Default look inside editor
        content_style: 'body { font-family: Helvetica, Arial, sans-serif; font-size:16px; }' +
            'img { max-width:100%; height:auto; }'
    });
}
//# sourceMappingURL=main.js.map